import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";
import logo from "../../assets/jeantnl-logo.png";

const navItems = [
	{ name: "Home", path: "/" },
	{ name: "About Us", path: "/about" },
	{ name: "Services", path: "/services" },
	{ name: "Areas of Practice", path: "/areas-of-practice" },
	{ name: "Contact", path: "/contact" },
];

const Navigation = () => {
	const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();

	return (
		<nav className="nav">
			<div className="top-contact-bar">
            <div className="contact-bar-content">
                
                {/* 📍 Address */}
                <span className="contact-item contact-address">
                    <a href="https://www.google.com/maps/place/Klein+St,+Benoni,+1501/@-26.1788512,28.284395,17z/data=!4m6!3m5!1s0x1e95163aca9d56f1:0x1c2e1f8b54cad097!8m2!3d-26.1780184!4d28.2875583!16s%2Fg%2F1ydp67k6g?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                        Address: Klein St, Lakefield, Benoni, 1501
                    </a>
                </span>
                
                <span className="separator">|</span>

                {/* 📞 Phone - Uses tel: link for mobile dialing */}
                <a href="tel: +27 82 676 9842" className="contact-item contact-phone">
                    Phone: +27 82 676 9842
                </a>
				{/* <a href="tel: +27 67 621 8734" className="contact-item contact-phone">
                    Phone: +27 67 621 8734
                </a> */}
                
                <span className="separator">|</span>
                
                {/* 📧 Email - Uses mailto: link for easy emailing */}
                <a href="mailto:info@jeantaxandlegal.co.za" className="contact-item contact-email">
                    Email: info@jeantaxandlegal.co.za
                </a>
            </div>
        </div>
			<div className="nav-container">
				{/* Logo Link */}
				<Link to="/" className="nav-logo">
					{/* <div className="logo-icon">JT</div> */}
					<img src={logo} alt="Jean Tax & Legal Logo" className="logo-icon" />
					<div className="logo-text">
						<div className="logo-name">Jean Tax & Legal</div>
						<div className="logo-sub">Practitioners</div>
					</div>
				</Link>

				{/* Desktop Navigation Links */}
				<div className="nav-links-desktop">
					{navItems.map(item => (
						<Link
							key={item.path}
							to={item.path}
							className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
						>
							{item.name}
							<span className="underline" />
						</Link>
					))}
					{/* Explicit link to Contact page */}
					<Link to="/contact" className="btn-consult">
						Book Consultation
					</Link>
				</div>

				{/* Mobile Menu Button */}
				<button 
					className="nav-mobile-btn" 
					onClick={() => setIsOpen(!isOpen)}
				>
					{isOpen ? "✕" : "☰"} 
				</button>
			</div>

			{/* Mobile Navigation Links (Conditionally Rendered) */}
			{isOpen && (
				<div className="nav-links-mobile">
					{navItems.map(item => (
						<Link
							key={item.path}
							to={item.path}
							onClick={() => setIsOpen(false)} // Close menu on click
							className={`nav-link-mobile ${location.pathname === item.path ? "active" : ""}`}
						>
							{item.name}
						</Link>
					))}
					<Link
						to="/contact" // Explicit link to Contact page
						className="btn-consult-mobile"
						onClick={() => setIsOpen(false)}
					>
						Book Consultation
					</Link>
				</div>
			)}
		</nav>
	);
};

export default Navigation;